import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Constants } from 'src/app/config/app.constants';
import { ChatServiceBase, CommonServiceBase} from 'khegm-ui-components';

@Injectable({
  providedIn: 'root'
})
export class ChatService extends ChatServiceBase {

  private src: string;
  private att_source: string;
  private env: string;
  private debug: boolean;

  constructor(@Inject(DOCUMENT) dom: Document, commonService: CommonServiceBase, constants: Constants) {
    super(dom, commonService);
    this.src = constants.GenesysCdnUrl;
    this.att_source = 'PGMarketing';
    this.env = constants.GenesysEnvironment;
    this.debug = false;
  }

  addGenesysChatWidget(): void {
    // Implementation for adding Genesys chat widget globally
    this.addGenesysChatWidgetBase({src: this.src, att_source: this.att_source, env: this.env, debug: this.debug});
  }
}
